// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__er3Cu","errorLogs":"styles_errorLogs__19Ma2"};